export enum RenderFx {
  MinLight = 1,
  ViewerModel = 2,
  WeaponModel = 4,
  FullBright = 8,
  DepthHack = 16,
  Translucent = 32,
  FrameLerp = 64,
  Beam = 128,
  CustomLight = 256,
  Glow = 512,
  ShellRed = 1024,
  ShellGreen = 2048,
  ShellBlue = 4096,
  IrVisible = 32768,
  ShellDouble = 65536,
  ShellHalfDam = 131072,
  MinLightPlus = 262144,
  ExtraLight = 524288,
  BeamLightning = 1048576,
  Flashlight = 2097152, // 1 << 21
}
